<template>
	<div>
		<!-- 下载记录 -->
		<form action="" class="w-100 layui-form" method="post">
			<div class="user-info3 w-100 between-center">
				<input type="text" class="layui-input" name="" id="test" value="" placeholder="起始时间 - 结束时间" />
				<input type="text" class="layui-input" name="" id="" value="" placeholder="文件名称" />
				<div class="btns">
					<input class="layui-btn layui-btn-normal" value="确定" @click="confirm"/>
					<input type="reset" class="layui-btn" value="重置" @click="reset"/>
				</div>
			</div>
		</form>
		<div class="w-100">
			<div class="no-content" style="display: flex;justify-content: center;">
				<img src="../../../static/img/no_data5.png">
			</div>
		</div>
		<table class="table table-hover w-100" v-if="false">
			<tr>
				<th><label class="checkbox-inline"><input type="checkbox" class="checkbox-style allCheckbox" name="" id="" value="" />文件名称</label></th>
				<th width="150">文件大小</th>
				<th width="230">下载日期</th>
				<th width="150">操作</th>
			</tr>
			<tr>
				<td><label class="checkbox-inline"><input type="checkbox" class="checkbox-style sonCheckbox" name="" id="" value="" />HLX-10-6060-45铝型材</label></td>
				<td>166M</td>
				<td>2021.05.31   15:25:15</td>
				<td><a href="">打开所在目录</a></td>
			</tr>
			<tr>
				<td><label class="checkbox-inline"><input type="checkbox" class="checkbox-style sonCheckbox" name="" id="" value="" />HLX-10-6060-45铝型材</label></td>
				<td>166M</td>
				<td>2021.05.31   15:25:15</td>
				<td><a href="">打开所在目录</a></td>
			</tr>
			<tr>
				<td><label class="checkbox-inline"><input type="checkbox" class="checkbox-style sonCheckbox" name="" id="" value="" />HLX-10-6060-45铝型材</label></td>
				<td>166M</td>
				<td>2021.05.31   15:25:15</td>
				<td><a href="">打开所在目录</a></td>
			</tr>
		</table>
		<div class="user-info4 w-100 between-center" v-if="false">
			<div class="f-l between-center">
				<label class="checkbox-inline"><input type="checkbox" class="checkbox-style allCheckbox" name="" id="" value="" />&nbsp;</label>
				<span>删除所选</span>
			</div>
			<div class="fanye gray">
				<div class="pull-right">
					<ul class="between-center">
						<li><a href="">&lt;</a></li>
						<li><a href="" class="active">1</a></li>
						<li><a href="">2</a></li>
						<li><a href="">3</a></li>
						<li><a href="">4</a></li>
						<li><a href="">5</a></li>
						<li><a href="">6</a></li>
						<li><a href="">&gt;</a></li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		message
	} from '@/common/common.js'
	export default{
		methods: {
			confirm() {
				message({
					message: '功能暂未开放',
					type: 'warning'
				})
			},
			reset() {
				message({
					message: '功能暂未开放',
					type: 'warning'
				})
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/userCenter/downloadRecord.vue